import * as types from './types';

const INITIAL_STATE = {
    loyaltyInfo: {},
    userInfo: {},
    identityId: undefined,
    orders: [],
    isLoggedIn: false,
    provider: undefined,
    isNewAccount: false,
};

function markAsNewAccount(state) {
    return {
        ...state,
        isNewAccount: true,
    };
}

function updateBillingAddress(state, action) {
    const {
        payload: data,
    } = action;

    return {
        ...state,
        userInfo: {
            ...state.userInfo,
            billingAddress: {
                ...state.userInfo.billingAddress,
                ...data.billingAddress,
            },
        },
    };
}

function updateUserName(state, action) {
    const {
        payload: data,
    } = action;

    const { firstName, lastName } = data;

    return {
        ...state,
        userInfo: {
            ...state.userInfo,
            firstName,
            lastName,
        },
    };
}

function setLoggedIn(state, action) {
    const {
        payload: data,
    } = action;

    return {
        ...state,
        isLoggedIn: true,
        provider: data.provider,
        identityId: data.identityId,
        loyaltyInfo: {
            ...data.loyaltyInfo,
        },
        userInfo: {
            ...data.userInfo,
        },
    };
}

function setLoggedOut() {
    return INITIAL_STATE;
}

function setUserOrders(state, action) {
    const {
        payload: data,
    } = action;

    return {
        ...state,
        orders: [...data],
    };
}

function updateUserOrder(state, action) {
    const {
        payload: data,
    } = action;

    const newOrders = state.orders.map((order) => {
        if (order.processingId === data.processingId) {
            return data;
        }

        return order;
    });

    return {
        ...state,
        orders: [...newOrders],
    };
}

function setTicketDownloadUrl(state, action) {
    const {
        payload: data,
    } = action;

    const orders = state.orders.map((order) => {
        if (order.processingId !== data.processingId) {
            return order;
        }

        return {
            ...order,
            ticket: {
                ...order.ticket,
                downloadUrl: data.downloadUrl,
            },
        };
    });

    return {
        ...state,
        orders: [
            ...orders,
        ],
    };
}

const handlers = {
    [types.MARK_AS_NEW_ACCOUNT]: markAsNewAccount,
    [types.UPDATE_BILLING_ADDRESS]: updateBillingAddress,
    [types.UPDATE_USER_NAME]: updateUserName,
    [types.SET_LOGGED_IN]: setLoggedIn,
    [types.SET_LOGGED_OUT]: setLoggedOut,
    [types.SET_TICKET_DOWNLOAD_URL]: setTicketDownloadUrl,
    [types.SET_USER_ORDERS]: setUserOrders,
    [types.UPDATE_USER_ORDER]: updateUserOrder,
};

export default function reducer(state = INITIAL_STATE, action) {
    if (handlers.hasOwnProperty(action.type)) {
        const handler = handlers[action.type];
        return handler(state, action);
    }

    return state;
}
